import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  commonPageFieldList,
  commonPageFieldListSuccess,
} from "../../../store/actions";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import { Row, Modal, Col, FormGroup, Label } from "reactstrap";
import { useHistory } from "react-router-dom";
import {
  ToDate,
  date_ymd_func,
  disablePriviousTodate,
  loginSelectedPartyID,
} from "../../../components/Common/CommonFunction";
import { updateWorkOrderListSuccess } from "../../../store/Production/WorkOrder/action";

import {
  delete_ProductionId,
  delete_ProductionIdSuccess,
  edit_ProductionId,
  getProductionListPage,
  ProductionIdReissue,
  ProductionIdReissueSuccess,
} from "../../../store/Production/ProductionRedux/actions";

import {
  getMaterialIssueListPage,
  MaterialReissueId,
} from "../../../store/Production/Matrial_Issue/action";

import * as report from "../../../Reports/ReportIndex";
import * as pageId from "../../../routes/allPageID";
import * as mode from "../../../routes/PageMode";
import * as url from "../../../routes/route_url";
import { getpdfReportdata } from "../../../store/Utilites/PdfReport/actions";
import { production_Edit_API } from "../../../helpers/backend_helper";
import ProductionMaster from "./ProductionMaster";

import { C_DatePicker, C_Select } from "../../../CustomValidateForm";
import {
  Go_Button,
  PageLoadingSpinner,
  C_Button,
} from "../../../components/Common/CommonButton";
import { initialFiledFunc } from "../../../components/Common/validationFunction";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import useCheckStockEntry from "../../../components/Common/commonComponent/CheckStockEntry";

const ProductionList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const currentDate_ymd = date_ymd_func();

  const [ModalOpen, setModalOpen] = useState({ Open: false, id: null });
  const [hederFilters, setHederFilters] = useState({
    fromdate: currentDate_ymd,
    todate: currentDate_ymd,
  });
  const [pageMode, setPageMode] = useState(mode.defaultList);
  const [otherState, setOtherState] = useState({
    masterPath: "",
    makeBtnShow: false,
    newBtnPath: "",
  });
  const [selectedItemDetails, setSelectedItemDetails] = useState([]);

  const reducers = useSelector((state) => ({
    goBtnLoading: state.ProductionReducer.loading,
    listBtnLoading: state.ProductionReducer.listBtnLoading,
    tableList: state.ProductionReducer.ProductionList,
    deleteMsg: state.ProductionReducer.deleteMsg,
    updateMsg: state.WorkOrderReducer.updateMsg,
    postMsg: state.OrderReducer.postMsg,
    editData: state.ProductionReducer.editData,
    userAccess: state.Login.RoleAccessUpdateData,
    pageField: state.CommonPageFieldReducer.pageFieldList,

    materialIssueList: state.MaterialIssueReducer.materialIssueList,
    reissueProductionMsg: state.ProductionReducer.reissueProductionMsg,
  }));

  const {
    pageField,
    materialIssueList,

    goBtnLoading,
    listBtnLoading,
    reissueProductionMsg,
  } = reducers;
  const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);
  const fields = { Material: null, IsReProcess: null };
  const [state, setState] = useState(() => initialFiledFunc(fields));
  const { values } = state;

  useEffect(() => {
    let page_Id = "";
    let masterPath = "";
    let newBtnPath = "";
    let makeBtnShow = false;

    const path = history.location.pathname;

    if (path === url.PRODUCTION_LIST) {
      const jsonBody = JSON.stringify({
        FromDate: "",
        ToDate: "",
        IsReIssue: 1,
        IsReprocess: 1,
        Party: loginSelectedPartyID(),
      });

      dispatch(getMaterialIssueListPage(jsonBody));
      page_Id = pageId.PRODUCTION_LIST;
      masterPath = url.PRODUCTION_MASTER;
      newBtnPath = url.PRODUCTION_STP;
    } else if (path === url.PRODUCTION_REISSUE_STP) {
      page_Id = pageId.PRODUCTION_REISSUE_STP;
      makeBtnShow = true;
      setPageMode(mode.modeSTPsave);
    } else if (path === url.VENDOR_PRODUCTION_LIST) {
      page_Id = pageId.VENDOR_PRODUCTION_LIST;
      masterPath = url.VENDOR_PRODUCTION;
      newBtnPath = url.VENDOR_PRODUCTION;
    }
    dispatch(commonPageFieldListSuccess(null));
    dispatch(commonPageFieldList(page_Id));

    setOtherState({ masterPath, makeBtnShow, newBtnPath });
    goButtonHandler();
  }, []);

  useEffect(() => {
    if (!reissueProductionMsg) return;

    if (
      reissueProductionMsg.Status === true &&
      reissueProductionMsg.StatusCode === 200
    ) {
      const jsonBody = JSON.stringify({
        FromDate: "",
        ToDate: "",
        IsReIssue: 1,
        IsReprocess: 1,
        Party: loginSelectedPartyID(),
      });
      dispatch(getMaterialIssueListPage(jsonBody));
      dispatch(ProductionIdReissueSuccess(null));
      customAlert({
        Type: 1,
        Message:
          reissueProductionMsg.Message || "Re-Issue completed successfully.",
        ActionButton: "OK",
        Icon: "mdi mdi-check-circle-outline",
        color: "success",
      });

      setModalOpen({ Open: false, id: null });
      setState((prev) => ({
        ...prev,
        values: { ...prev.values, Material: null, IsReprocess: null },
      }));
    } else if (reissueProductionMsg.Status === false) {
      dispatch(ProductionIdReissueSuccess(null));
      customAlert({
        Type: 4,
        Message: reissueProductionMsg.Message,
      });
    }
  }, [reissueProductionMsg]);

  useEffect(() => {
    if (ModalOpen.Open) {
      // reset dropdowns every time modal opens
      setState((prev) => ({
        ...prev,
        values: { Material: null, IsReProcess: null },
      }));
      setSelectedItemDetails([]);
    }
    if (!ModalOpen.Open) {
      setSelectedItemDetails([]);
    }
  }, [ModalOpen.Open]);

  const goButtonHandler = () => {
    const { fromdate, todate } = hederFilters;

    const jsonBody = JSON.stringify({
      FromDate: fromdate,
      ToDate: todate,
      Party: loginSelectedPartyID(),
    });

    dispatch(getProductionListPage(jsonBody));
  };

  const fromdateOnchange = (e, date) => {
    setHederFilters((prev) => ({ ...prev, fromdate: date }));
  };

  const todateOnchange = (e, date) => {
    setHederFilters((prev) => ({ ...prev, todate: date }));
  };

  const MaterialOnchange = (selectedOption) => {
    setState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        Material: selectedOption,
      },
    }));
    if (selectedOption?.fullData?.ItemDetails) {
      setSelectedItemDetails(selectedOption.fullData.ItemDetails);
    } else {
      setSelectedItemDetails([]);
    }
  };

  const IsReprocessOnchange = (selectedOption) => {
    setState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        IsReProcess: selectedOption,
      },
    }));
    if (selectedOption?.fullData?.ItemDetails) {
      setSelectedItemDetails(selectedOption.fullData.ItemDetails);
    } else {
      setSelectedItemDetails([]);
    }
  };

  const tog_backdrop = () => {
    setModalOpen({ Open: false, id: null });
  };

  const handleSave = () => {
    const Production = ModalOpen?.id;
    const MaterialIssue = values.Material?.value || values.IsReProcess?.value;

    if (!MaterialIssue) {
      customAlert({
        Type: 4,
        Message: "Please select a Material Issue",
      });
      return;
    }

    if (!Production) {
      customAlert({
        Type: 4,
        Message: "Production ID not found!",
      });
      return;
    }

    const jsonBody = JSON.stringify({
      MaterialIssue,
      Production,
    });

    dispatch(ProductionIdReissue({ jsonBody }));

  };
    const { Actionhandler } = useCheckStockEntry(commonPartyDropSelect);
  const editBodyfunc = (config) => {
    const { rowData } = config;
    Actionhandler({
      transactionDate: date_ymd_func(), // ✅ row's own date — confirm exact field name
      callback: () => {
        dispatch(edit_ProductionId({ ...config }));
      }
    });
  };

  const deleteBtnFunc = (config) => {
    const { rowData } = config;
    Actionhandler({
      transactionDate: date_ymd_func(), // ✅ row's own date — confirm exact field name
      callback: () => {
        dispatch(delete_ProductionId({ ...config }));
      }
    });
  };

  const materialOptions = materialIssueList
    .filter((i) => i.IsReIssue === true && i.IsReIssueSave === 0)
    .map((i) => ({
      value: i.id,
      label: `${i.FullMaterialIssueNumber}`,
      fullData: i,
    }));

  const isReprocessOptions = materialIssueList
    .filter((i) => i.IsReProcess === true && i.IsReProcessSave === 0)
    .map((i) => ({
      value: i.id,
      label: `${i.FullMaterialIssueNumber}`,
      fullData: i,
    }));

  const action = {
    getList: getMaterialIssueListPage,
    editId: edit_ProductionId,
    updateSucc: updateWorkOrderListSuccess,
    deleteSucc: delete_ProductionIdSuccess,
    productionId: ProductionIdReissue,
    productionIdSucc: ProductionIdReissueSuccess,
  };

  function makeBtnFunc(config) {
    setModalOpen({ Open: true, id: config[0].id });
  }

  const downBtnFunc = (row) => {
    const ReportType = report.Stock;
    dispatch(getpdfReportdata(production_Edit_API, ReportType, row.id));
  };

  return (
    <React.Fragment>
      <PageLoadingSpinner isLoading={goBtnLoading || !pageField} />
      <div className="page-content">
        {/* Header Filters */}
        <div className="px-2 c_card_filter text-black">
          <Row>
            <Col sm="5">
              <FormGroup className="row mt-3">
                <Label className="col-sm-5 p-2" style={{ width: "83px" }}>
                  FromDate
                </Label>
                <Col sm="6">
                  <C_DatePicker
                    name="fromdate"
                    value={hederFilters.fromdate}
                    onChange={fromdateOnchange}
                    options={{
                      altInput: true,
                      altFormat: "d-m-Y",
                      dateFormat: "Y-m-d",
                    }}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm="5">
              <FormGroup className="row mt-3">
                <Label
                  className="col-sm-1 p-2"
                  style={{ width: "65px", marginRight: "0.4cm" }}
                >
                  ToDate
                </Label>
                <Col sm="6">
                  <C_DatePicker
                    options={{
                      minDate: disablePriviousTodate({
                        fromDate: hederFilters.fromdate,
                      }),
                      altInput: true,
                      altFormat: "d-m-Y",
                      dateFormat: "Y-m-d",
                    }}
                    name="todate"
                    value={ToDate({
                      FromDate: hederFilters.fromdate,
                      Todate: hederFilters.todate,
                    })}
                    onChange={todateOnchange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm="1" />
            <Col sm="1" className="mt-3">
              <Go_Button loading={goBtnLoading} onClick={goButtonHandler} />
            </Col>
          </Row>
        </div>

        {/* Main Table */}
        {pageField && (
          <CommonPurchaseList
            action={action}
            reducers={reducers}
            showBreadcrumb={false}
            masterPath={otherState.masterPath}
            newBtnPath={otherState.newBtnPath}
            makeBtnShow={otherState.makeBtnShow}
            pageMode={pageMode}
            goButnFunc={goButtonHandler}
            downBtnFunc={downBtnFunc}
            makeBtnFunc={makeBtnFunc}
            makeBtnName={"make ReIssue"}
            ButtonMsgLable={"Production"}
            deleteName={"ItemName"}
            MasterModal={ProductionMaster}
            editBodyfunc={editBodyfunc}      // ✅ added
            deleteBtnFunc={deleteBtnFunc}    // ✅ added
          />
        )}

        {/* Modal */}
        <Modal
          isOpen={ModalOpen.Open}
          toggle={tog_backdrop}
          className="modal-dialog-centered"
        >
          <div style={{ width: "150%", margin: "auto", position: "relative" }}>
            <div className="p-5 bg-light rounded shadow-sm">
              <h3 className="mb-3 text-center">Material Issue</h3>
              <hr />
              <Row className="mb-4">
                <Col>
                  <div className="bg-white p-4 rounded shadow-sm border mt-3">
                    <Row className="gx-3">
                      <Col lg={6}>
                        <FormGroup className="mb-2">
                          <Label>Material Re-Issue</Label>
                          {materialOptions.length > 0 ? (
                            <C_Select
                              name="Material"
                              classNamePrefix="select2-MaterialIssue"
                              value={values.Material}
                              options={materialOptions}
                              onChange={MaterialOnchange}
                              isLoading={listBtnLoading}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 2,
                                }),
                              }}
                            />
                          ) : (
                            <p>No Material Issues available</p>
                          )}
                        </FormGroup>
                      </Col>

                      <Col lg={6}>
                        <FormGroup className="mb-2">
                          <Label>Material IsReProcess</Label>
                          {isReprocessOptions.length > 0 ? (
                            <C_Select
                              name="IsReProcess"
                              classNamePrefix="select2-IsReprocess"
                              value={values.IsReProcess}
                              options={isReprocessOptions}
                              onChange={IsReprocessOnchange}
                              isLoading={listBtnLoading}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 2,
                                }),
                              }}
                            />
                          ) : (
                            <p>No Reprocess Materials</p>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    {selectedItemDetails.length > 0 && (
                      <div className="mt-4 bg-white p-3 rounded shadow-sm border">
                        <h5 className="mb-3">Item Details</h5>

                        <table className="table table-bordered table-sm text-center">
                          <thead>
                            <tr>
                              <th>Sr No</th>
                              <th>Item Name</th>
                              <th>Issue Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedItemDetails.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{ textAlign: "left" }}>{item.ItemName}</td>
                                <td>{item.IssueQuantity}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            {(materialOptions.length > 0 || isReprocessOptions.length > 0) && (
              <div
                style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "12.5%",
                  transform: "translateX(-50%)",
                }}
              >
                <C_Button
                  className="btn btn-primary"
                  spinnerColor="white"
                  style={{ width: "90px" }}
                  onClick={handleSave}
                >
                  Save
                </C_Button>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default ProductionList;
